export default function () {
    return {
        selectedPreOrder: {},
    };
}
